// extracted by mini-css-extract-plugin
export default {"user_badge":"LoginBadge_user_badge__FgMaw","user_icon":"LoginBadge_user_icon__9Ca91"};